import * as Rox from "rox-browser";

export const payments = {
  jpmorgan: new Rox.Flag(),
  workflowv4: new Rox.Flag(),
  construagil_ecollect: new Rox.Flag(),
  enabled7727Payment: new Rox.Flag(),
  enabledBanorte: new Rox.Flag(),
  enableSalesOrder: new Rox.Flag(),
  advance_payment__v5: new Rox.Flag(),
  regular_payment__v5: new Rox.Flag(),
  jpmorgan_checkout: new Rox.Flag(),
  jpmorgan_checkout_redirected: new Rox.Flag(),
  boa_checkout_redirected: new Rox.Flag(),
  boa_url_production: new Rox.Flag(),
  disableBanamex: new Rox.Flag(),
  new_logo_banamex: new Rox.Flag(),
  banorte_api_version: new Rox.RoxNumber(1, [1, 2]),
  customer_name_field: new Rox.Flag(),
  bofa_filter: new Rox.Flag(),
  bofa_Send_All_Detail: new Rox.Flag(),
};
